var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8 col-md-offset-2"
  }, [_c('h1', {
    staticClass: "text-center",
    staticStyle: {
      "margin": "40px 0"
    }
  }, [_vm._v("\n                    Bem-vindo à Suite CRM IBOPE DTM!\n                ")]), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v("\n                    A partir de agora você tem acesso às nossas ferramentas para gerenciamento de campanhas e Business Intelligence. "), _c('br'), _vm._v("\n                    Aprimore os dados gerados pelo seu cliente e estratégias com comunicações cada vez mais personalizadas, assertivas e com gerenciamento facilitado de \n                    todas as campanhas.\n                ")])])])])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65271836","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Portal.vue
// module id = Wfmy
// module chunks = 1